var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.6,
    height: 67.7,
    viewBox: "0 0 67.6 67.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 9.91,
    y1: 57.74,
    x2: 57.69,
    y2: 9.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f48a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,67.7A33.85,33.85,0,1,0,0,33.8,33.82,33.82,0,0,0,33.8,67.7Z",
    fillRule: "evenodd",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.09,33.59c-.51-.22-1.07-.44-1.64-.67V20.83a15.11,15.11,0,0,1,2.06.38,15.43,15.43,0,0,1,4.41,1.92l.52.3a1.76,1.76,0,1,0,1.72-3.06l-.5-.28a19,19,0,0,0-5.3-2.28,17.78,17.78,0,0,0-2.91-.51V13.2a1.75,1.75,0,0,0-3.5,0v4c-.55,0-1.11.07-1.65.15a10.28,10.28,0,0,0-6.24,3.19,8.17,8.17,0,0,0-1.91,5.84,7.69,7.69,0,0,0,4,6.17A38,38,0,0,0,33,35.29v12.3A13.1,13.1,0,0,1,30,47.1a11.39,11.39,0,0,1-5.32-3.18,1.75,1.75,0,0,0-2.4,2.56,14.81,14.81,0,0,0,6.8,4A16.75,16.75,0,0,0,33,51.1v3.4a1.75,1.75,0,0,0,3.5,0V51a15.75,15.75,0,0,0,3.06-.71,9.79,9.79,0,0,0,6.05-6,6.79,6.79,0,0,0-1.24-6.47C43,36,40.89,34.79,38.09,33.59Zm-9.06-4c-2-1.25-2.32-2.49-2.38-3.42a4.64,4.64,0,0,1,1.09-3.37,6.79,6.79,0,0,1,4.09-2c.36-.05.74-.07,1.12-.1V31.51A28.89,28.89,0,0,1,29,29.62Zm13.2,13.55A6.31,6.31,0,0,1,38.31,47a11.24,11.24,0,0,1-1.86.47V36.7l.26.11c2.71,1.16,4,2,4.81,3.07A3.36,3.36,0,0,1,42.23,43.17Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.669f0ca00acf5b64d9c3c213a8660c51.svg";
export { ForwardRef as ReactComponent };